export default __webpack_public_path__ + "static/media/14.17e525d7.jpg";